import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";

export default function UpdatesBar({ news = [] }) {
  const updates = useMemo(
    () => news.filter((item) => item && item.title),
    [news]
  );
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
    if (updates.length < 2) return undefined;

    const interval = window.setInterval(() => {
      setActiveIndex((index) => (index + 1) % updates.length);
    }, 6500);

    return () => window.clearInterval(interval);
  }, [updates]);

  if (!updates.length) return null;

  const update = updates[activeIndex];

  return (
    <Box
      dir="rtl"
      role="region"
      aria-label="עדכונים חשובים"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: 0.8, sm: 1.25 },
        width: "100%",
        minHeight: 48,
        mt: 1.25,
        mb: { xs: 1.5, md: 2 },
        px: { xs: 1.1, sm: 1.6 },
        py: 0.65,
        boxSizing: "border-box",
        borderRadius: "15px",
        color: "#173B57",
        background: "linear-gradient(90deg, #FFF8E9 0%, #FFFFFF 48%, #EEF8FF 100%)",
        border: "1px solid rgba(232, 159, 38, .28)",
        boxShadow: "0 7px 20px rgba(31, 78, 121, .08)",
        overflow: "hidden",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.65, flex: "0 0 auto", color: "#D97B08" }}>
        <CampaignRoundedIcon sx={{ fontSize: 22 }} />
        <Typography sx={{ display: { xs: "none", sm: "block" }, fontFamily: "Assistant", fontWeight: 900, fontSize: ".9rem" }}>
          עדכון חשוב
        </Typography>
      </Box>

      <Box sx={{ width: "1px", height: 24, bgcolor: "rgba(23,59,87,.14)", flex: "0 0 auto" }} />

      <Typography
        key={update.id || activeIndex}
        sx={{
          minWidth: 0,
          flex: 1,
          fontFamily: "Assistant",
          fontWeight: 750,
          fontSize: { xs: ".86rem", sm: ".95rem" },
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {update.title}
      </Typography>

      <Button
        component={NavLink}
        to={`/shownews/${update.id}`}
        endIcon={<ArrowBackRoundedIcon />}
        sx={{
          flex: "0 0 auto",
          minWidth: 0,
          px: { xs: 0.6, sm: 1 },
          fontFamily: "Assistant",
          fontWeight: 900,
          fontSize: { xs: ".78rem", sm: ".86rem" },
          color: "#0877C9",
          textTransform: "none",
          whiteSpace: "nowrap",
        }}
      >
        לפרטים
      </Button>
    </Box>
  );
}
